module.exports = __webpack_public_path__ + "img/pinfo.f1244318.svg";